import React, {useState, useRef, useEffect} from "react";
import * as THREE from "three";
import InSceneComment from "./InSceneComment"
import { useObjectStore } from "../zustand/objects";

const CommentsMapped = ({currentObjectArtboard, artboards, orbitControl}) => {

const {
    threads,
    showingComments
  } = useObjectStore();


    return (
        <>
        {
            threads && threads[currentObjectArtboard] && threads[currentObjectArtboard].map((mapped, i) => mapped.position.x && <InSceneComment key={mapped.id} id={mapped.id} position={mapped.position} created_date={mapped.created_at} artboard={mapped.artboard} currentObjectArtboard={currentObjectArtboard}/>
            )
        }
        </>
    )
}

export default CommentsMapped